import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Phone, MessageCircle, Send } from 'lucide-react';
export function CTA() {
  return <section className="py-24 bg-gray-50 relative overflow-hidden" data-id="element-68">
      <div className="container mx-auto px-6 md:px-12" data-id="element-69">
        <div className="grid md:grid-cols-2 gap-16 items-center" data-id="element-70">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="w-full h-[400px] md:h-[500px] bg-gray-200 rounded-lg overflow-hidden relative shadow-sm" data-id="element-71">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d81312.51381666872!2d30.4426227284752!3d50.44095101037562!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40d4ce50f8b6e3c3%3A0xb528dc4d6bfc05cb!2sKyiv%2C%20Ukraine%2C%2002000!5e0!3m2!1sen!2sus!4v1715000000000!5m2!1sen!2sus" width="100%" height="100%" style={{
            border: 0
          }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Google Maps Kyiv" data-id="element-72"></iframe>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-73">
            <h2 className="font-heading text-4xl md:text-5xl text-dark mb-6" data-id="element-74">
              Готові до змін?
            </h2>
            <div className="w-12 h-px bg-accent mb-8" data-id="element-75"></div>
            <p className="text-gray-600 font-light mb-10 leading-relaxed" data-id="element-76">
              Запишіться на сеанс або зв'яжіться зі мною зручним для вас
              способом для безкоштовної консультації. Я завжди на зв'язку!
            </p>

            <div className="space-y-6" data-id="element-77">
              <a href="tel:+380971214358" className="flex items-center text-lg text-dark hover:text-accent transition-colors group" data-id="element-78">
                <div className="w-12 h-12 bg-white border border-gray-200 rounded-full flex items-center justify-center mr-6 group-hover:border-accent transition-colors" data-id="element-79">
                  <Phone className="text-dark group-hover:text-accent transition-colors" size={20} data-id="element-80" />
                </div>
                <span className="font-medium tracking-wide" data-id="element-81">
                  +38 097 121 43 58
                </span>
              </a>

              <a href="#viber" className="flex items-center text-lg text-dark hover:text-accent transition-colors group" data-id="element-82">
                <div className="w-12 h-12 bg-white border border-gray-200 rounded-full flex items-center justify-center mr-6 group-hover:border-accent transition-colors" data-id="element-83">
                  <MessageCircle className="text-dark group-hover:text-accent transition-colors" size={20} data-id="element-84" />
                </div>
                <span className="font-medium tracking-wide" data-id="element-85">Viber</span>
              </a>

              <a href="#telegram" className="flex items-center text-lg text-dark hover:text-accent transition-colors group" data-id="element-86">
                <div className="w-12 h-12 bg-white border border-gray-200 rounded-full flex items-center justify-center mr-6 group-hover:border-accent transition-colors" data-id="element-87">
                  <Send className="text-dark group-hover:text-accent transition-colors" size={20} data-id="element-88" />
                </div>
                <span className="font-medium tracking-wide" data-id="element-89">Telegram</span>
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}